import ReplyIcon from '@mui/icons-material/Reply';

export const OutgoingPackageIcon = () => (
  <ReplyIcon
    sx={{
      position: 'absolute',
      color: '#4cb151',
      top: '13px',
      left: '15px',
      transform: 'rotateY(180deg)',
    }}
  />
);
